var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ApiVolumeArea } from './api-volume/ApiVolumeArea';
import { DataAccessView } from './access/DataAccessView';
import { DataSecurityApplicationOverview } from './DataSecurityApplicationOverview';
import { DataSecurityDashboard } from './DataSecurityDashboard';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { FeatureRouteWrapper } from '@ui/features';
import { getPastDate } from '@sonar-software/sonar-ts-lib';
import { IntegratedAppsView } from './integrated-applications';
import { MonitorsView } from './monitors';
import React from 'react';
import { SetupAuditTrailViewArea } from './audit-trail/SetupAuditTrailView';
import { useQueryParams } from '@hooks';
import { BASE_ROUTES, PARAMS } from '@sonar-software/sonar-ts-constants';
import { Route, Routes, useLocation } from 'react-router-dom';
export const DataSecurityView = () => {
    const location = useLocation();
    const { queryParams, updateParams } = useQueryParams({
        defaultParams: {
            dateRange: { start: getPastDate(7) }
        },
        transform: (newParams, params, combined) => {
            var _a, _b;
            const { userSelectedGroup } = combined, rest = __rest(combined, ["userSelectedGroup"]);
            const appGroupFallback = params.appGroup === userSelectedGroup ? userSelectedGroup : undefined;
            return Object.assign(Object.assign({}, rest), { appGroup: (_b = (_a = newParams.userSelectedGroup) !== null && _a !== void 0 ? _a : rest.appGroup) !== null && _b !== void 0 ? _b : appGroupFallback });
        }
    });
    return (React.createElement(Routes, null,
        React.createElement(Route, { element: React.createElement(FeatureRouteWrapper, { feature: FeatureFlag.DataSecurityDashboard },
                React.createElement(DataSecurityDashboard, { onViewChange: updateParams, viewParams: queryParams })), path: '' }),
        React.createElement(Route, { element: React.createElement(FeatureRouteWrapper, { feature: FeatureFlag.DataSecurityDashboard },
                React.createElement(DataSecurityApplicationOverview, { key: location.pathname, onViewChange: updateParams, viewParams: queryParams })), path: PARAMS.ID }),
        React.createElement(Route, { element: React.createElement(FeatureRouteWrapper, { feature: FeatureFlag.DataSecurityDashboard },
                React.createElement(ApiVolumeArea, null)), path: BASE_ROUTES.API_VOLUME }),
        React.createElement(Route, { element: React.createElement(SetupAuditTrailViewArea, null), path: BASE_ROUTES.SETUP_AUDIT_TRAIL }),
        React.createElement(Route, { element: React.createElement(MonitorsView, null), path: BASE_ROUTES.MONITORS }),
        React.createElement(Route, { element: React.createElement(DataAccessView, null), path: BASE_ROUTES.DATA_ACCESS }),
        React.createElement(Route, { element: React.createElement(IntegratedAppsView, null), path: `${BASE_ROUTES.APPLICATION_SETUP}/*` })));
};
